import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonService } from '../../../services/common.service';
import { LicenceResultsModalComponent } from '../licence-results-modal/licence-results-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vrm-view-licence-results-modal-button',
  templateUrl: './view-licence-results-modal-button.component.html',
  styleUrls: ['./view-licence-results-modal-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewLicenceResultsModalButtonComponent implements ICellRendererAngularComp {
  static readonly VIEW_DETAILS = 'view details';

  protected displayValue: string = null;
  protected displayButton = false;
  private firstName: string = null;
  private lastName: string = null;
  private pin: string = null;

  public constructor(private commonService: CommonService, private dialog: MatDialog) {}

  public agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
    this.displayButton = params.value?.toLowerCase() === ViewLicenceResultsModalButtonComponent.VIEW_DETAILS;
    this.firstName = params.data.firstName;
    this.lastName = params.data.lastName;
    this.pin = params.data.pin;
  }

  public openDialog(): void {
    this.dialog.open(LicenceResultsModalComponent, {
      maxHeight: this.commonService.isMobileViewport ? '80%' : '',
      maxWidth: this.commonService.isMobileViewport ? '80%' : '',
      height: '80%',
      width: this.commonService.isMobileViewport ? '80%' : '95%',
      data: {
        pin: this.pin,
        firstName: this.firstName,
        lastName: this.lastName,
      },
    });
  }

  public refresh(): boolean {
    return false;
  }
}
